import { defineComponent as _defineComponent } from 'vue'
import { authUsersApi } from '@/api';
import Button from '@/components/buttons/Button.vue';
import Dialog from '@/components/dialog/Dialog.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import BubbleIcon from '@/components/interface/BubbleIcon.vue';
import localization from '@/i18n';
import { useOpen } from '@/lib/composition/dialog';
import { Icon } from '@/lib/enum/Icon';
import { showSuccess } from '@/plugins/ToastNotifications';
import { email, getErrorMessages, required } from '@/plugins/vuelidate';
import { redirect } from '@/router/router';
import { routes } from '@/router/routes';
import store from '@/store';
import { User } from '@sentry/vue';
import useVuelidate from '@vuelidate/core';
import { reactive, ref } from 'vue';

enum VerifyEmailStageEnum {
  Verify = 'Verify',
  ChangeEmail = 'ChangeEmail',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UnverifiedUserDialog',
  props: {
    value: { type: Boolean },
    user: null
  },
  emits: ["input", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  user: User;
}





const open = useOpen(() => props.value, emit);

const stage = ref<VerifyEmailStageEnum>(VerifyEmailStageEnum.Verify);
const loading = ref<boolean>(false);

const formValues = reactive({
  email: props.user.email,
});
const v$ = useVuelidate(
  {
    email: {
      required,
      email,
    },
  },
  formValues,
);

const closeChangeEmail = (): void => {
  stage.value = VerifyEmailStageEnum.Verify;
  formValues.email = props.user.email;
};

const resendVerificationEmail = async (
  updateAddress: boolean,
): Promise<void> => {
  loading.value = true;
  await authUsersApi
    .resendConfirmationEmail({
      resendConfirmationEmailData: {
        newEmail: updateAddress ? formValues.email : undefined,
      },
    })
    .then(() => {
      showSuccess(
        localization.tc('successMessage.userEmailVerificationResent'),
      );
      store.dispatch('fetchAuthenticatedUser');
      closeChangeEmail();
    })
    .finally(() => {
      loading.value = false;
    });
};

return { __sfc: true,props, emit, open, VerifyEmailStageEnum, stage, loading, formValues, v$, closeChangeEmail, resendVerificationEmail, Button, Dialog, TextInput, BubbleIcon, Icon, email, getErrorMessages, redirect, routes }
}

})